/** @format */

export const getTextColor = (count: number, max: number) => {
    return count > max
        ? 'var(--colors-state-error)'
        : 'var(--colors-text-tertiary)';
};
